(function(){
'use strict';
function setupHeader(header){
 if(header.dataset.shirosMenusReady==='true')return;header.dataset.shirosMenusReady='true';
 var dropdown=header.querySelector('.shiros-nav-dropdown');
 if(!dropdown)return;
 var menu=header.querySelector('.shiros-mobile-menu');
 var toggle=header.querySelector('.shiros-menu-toggle');
 var fine=window.matchMedia('(hover: hover) and (pointer: fine)');
 dropdown.addEventListener('pointerenter',function(ev){if(fine.matches&&ev.pointerType!=='touch')dropdown.open=true});
 dropdown.addEventListener('pointerleave',function(ev){if(fine.matches&&ev.pointerType!=='touch')dropdown.open=false});
 document.addEventListener('pointerdown',function(ev){if(!dropdown.contains(ev.target))dropdown.open=false;if(menu&&!menu.contains(ev.target)&&toggle&&!toggle.contains(ev.target)&&menu.classList.contains('is-open')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');}});
 document.addEventListener('keydown',function(ev){if(ev.key==='Escape'){var wasOpen=dropdown.open;dropdown.open=false;if(menu&&menu.classList.contains('is-open')){wasOpen=true;menu.classList.remove('is-open');if(toggle)toggle.setAttribute('aria-expanded','false');}if(wasOpen)dropdown.querySelector('summary')?.focus();}});
 dropdown.addEventListener('focusout',function(ev){if(!dropdown.contains(ev.relatedTarget))dropdown.open=false});
}
function boot(){document.querySelectorAll('.shiros-site-header').forEach(setupHeader)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
document.addEventListener('shopify:section:load',boot);
})();
